import { render, staticRenderFns } from "./EstoqueAtendimento.vue?vue&type=template&id=16b26dca&scoped=true&"
import script from "./EstoqueAtendimento.vue?vue&type=script&lang=js&"
export * from "./EstoqueAtendimento.vue?vue&type=script&lang=js&"
import style0 from "./EstoqueAtendimento.vue?vue&type=style&index=0&id=16b26dca&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b26dca",
  null
  
)

export default component.exports